import { EWorkshopPublicPolicy } from '@lifk/types';
import { z } from 'zod';
import { UUIDValidationSchema } from './uuid';
const BaseWorkshopValidationSchema = z.object({
    title: z.string(),
    date: z.string(),
    status: z.string(),
    hideCosts: z.boolean().optional(),
    isSample: z.boolean().optional()
});
const WorkshopValidationSchema = BaseWorkshopValidationSchema;
const WorkshopUpdateValidationSchema = BaseWorkshopValidationSchema.extend({
    _id: UUIDValidationSchema
});
const WorkshopPublicPolicyValidationSchema = z.object({
    id: UUIDValidationSchema,
    publicPolicy: z.union([z.nativeEnum(EWorkshopPublicPolicy), z.null()])
});
const WorkshopIdQueryValidationSchema = z.object({
    workshopId: UUIDValidationSchema
});
export { WorkshopIdQueryValidationSchema, WorkshopPublicPolicyValidationSchema, WorkshopUpdateValidationSchema, WorkshopValidationSchema };
//# sourceMappingURL=workshop.js.map